import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import { track } from "@/lib/track";
import { shopifyPageView } from "@/lib/shopifyAnalytics";

export const SmoothScroll = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
    track("page_view", { path: pathname });
    shopifyPageView(pathname);
  }, [pathname]);

  return null;
};
